import React from "react";
import { ServicesFooter } from "./services-footer"

/**
 * Componente para mostrar el servicio Servicios Digitales.
 *
 * @component
 * 
 */

export const ServiciosDigitales = (props) => {
    const [width, setWidth] = React.useState(window.innerWidth);
    const breakpoint = 620;

    React.useEffect(() => {
        /* Inside of a "useEffect" hook add an event listener that updates
        the "width" state variable when the window size changes */
        window.addEventListener("resize", () => setWidth(window.innerWidth));

        /* passing an empty array as the dependencies of the effect will cause this
        effect to only run when the component mounts, and not each time it updates.
        We only want the listener to be added once */
    }, []);

  return (
    <div id="service-detail" className="text-center">
        <div className="col-md-8 col-md-offset-2 section-title">
            <h2><span className="title">Servicios</span></h2>
        </div>
        <div className="col-md-12 imgMain paddingRightLeft0 text-right">
            <img alt="Servicios Digitales" src={width < breakpoint ? "/img/services/ServiciosDigitales/ServiciosDigitales_img1_mob.webp" : "/img/services/ServiciosDigitales/ServiciosDigitales_img1.webp"}></img>
            <div className="text-left titleService">
                <p>Servicios <br></br>Digitales</p>
            </div>
        </div>

        {width < breakpoint ? 
            <div style={{ paddingBottom: '64px' }}>
                <div className="paddingTopBottom8">
                    &nbsp;
                </div>
                <div className="container">
                    <div className="">
                        <div className="col-md-12">
                            <div className="col-md-6 text-3">
                                <p>Ofrecemos una amplia gama de servicios para ayudarte a maximizar tu presencia en los medios. Desde la planificación estratégica hasta la ejecución de campañas, nos encargamos de cada detalle para garantizar que tu mensaje llegue a la audiencia adecuada en el momento oportuno.</p>
                            </div>
                            <div className="col-md-6">
                                <img alt="Servicios Digitales" src="/img/services/ServiciosDigitales/ServiciosDigitales_img2.webp"></img>
                            </div>
                        </div>
                        <div className="col-md-12 paddingTopBottom8">
                            <hr className="hrGeneral"></hr>
                        </div>
                        <div className="col-md-12">
                            <div className="col-md-6 text-4">
                                <p>Una estrategia integral e integrada</p>
                            </div>
                            <div className="col-md-6 text-5">
                                <p>Nuestra estrategia está respaldada por datos del entorno, las audiencias, tu negocio y los medios propios, además de diversas fuentes de información. Más allá del alcance y la frecuencia, adoptamos un enfoque analítico, estratégico y creativo para transformar tu negocio.</p>
                            </div>
                        </div>
                        <div className="col-md-12">
                            <hr className="hrGeneral"></hr>
                        </div>
                        <div className="col-md-12 ">
                            <div className="col-md-6 text-4">
                                <p>Potenciamos tu rendimiento <br className="visible-md visible-lg"></br>
                                    y reducimos los costes de medios <br className="visible-md visible-lg"></br>
                                    de comunicación con un modelo 4D.</p>
                            </div>
                            <br className="visible-xs"></br>
                            <br className="visible-xs"></br>
                            <div className="col-md-6 text-5">
                                <div className="col-md-12 col-xs-12 text-left icono paddingRightLeft0 paddingTopBottom8">
                                    <div className="col-md-2 col-xs-2 paddingRightLeft0">
                                        <img alt="Exploracion" src="/img/services/ServiciosDigitales/Icono_Exploracion.webp"></img>
                                    </div>
                                    <div className="col-md-10 col-xs-10">
                                        <span className="texto"><b>Exploración:</b> analizamos el mercado, la competencia y el público objetivo para obtener una visión clara del panorama actual y las oportunidades clave.</span>
                                    </div>
                                </div>
                                <div className="col-md-12 col-xs-12 text-left icono paddingRightLeft0 paddingTopBottom8">
                                    <div className="col-md-2 col-xs-2 paddingRightLeft0">
                                        <img alt="Estrategia" src="/img/services/ServiciosDigitales/Icono_Estrategia.webp"></img>
                                    </div>
                                    <div className="col-md-10  col-xs-10">
                                        <span className="texto"><b>Estrategia:</b> combinamos diferentes elementos para crear un plan sólido y coherente.<br></br></span>
                                    </div>
                                </div>
                                <div className="col-md-12 col-xs-12 text-left icono paddingRightLeft0 paddingTopBottom16">
                                    <div className="col-md-2 col-xs-2 paddingRightLeft0">
                                        <img alt="Implementacion" src="/img/services/ServiciosDigitales/Icono_Implementacion.webp"></img>
                                    </div>
                                    <div className="col-md-10 col-xs-10">
                                        <span className="texto"><b>Implementación:</b> ponemos en marcha el plan de acción de manera eficiente y precisa, maximizando la cobertura y el impacto de los medios de comunicación.</span>
                                    </div>
                                </div>
                                <div className="col-md-12 col-xs-12 text-left icono paddingRightLeft0 paddingTopBottom16">
                                    <div className="col-md-2 col-xs-2 paddingRightLeft0">
                                        <img alt="Smart Data" src="/img/services/ServiciosDigitales/Icono_SmartData.webp"></img>
                                    </div>
                                    <div className="col-md-10 col-xs-10">
                                        <span className="texto"><b>Smart Data Driven:</b> Utilizamos datos avanzados y tecnología para extraer conocimientos valiosos de las métricas y el comportamiento del público objetivo, mejorando continuamente los resultados.</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <br className="visible-xs"></br>
                <img alt="Servicios Digitales" src="/img/services/CrecimientoExpo/CrecimientoExpo_img3_mob.webp"></img>
                <div className="col-md-12 col-xs-12 paddingRightLeft0">
                <div className="col-md-12 col-xs-12 text-2 paddingRightLeft0">
                        <div className="col-md-6 col-xs-10 col-xs-offset-1 text-2 paddingRightLeft0">
                            <p>Desbloquea el éxito de tu proyecto de medios con un modelo innovador que fusiona estrategia, táctica y negocio. </p>
                        </div>
                    </div>
                </div>
            </div> 
        :
            <div>
                <div className="paddingTopBottom16">
                    &nbsp;
                </div>
                <div className="paddingTopBottom16">
                    &nbsp;
                </div>
                <div className="paddingTopBottom16">
                    &nbsp;
                </div>
                <div className="container-fluid padding-fluid">
                    <div className="">
                        <div className="col-md-12 paddingRightLeft0">
                            <div className="col-md-6 text-3">
                                <p>Ofrecemos una amplia gama de servicios para ayudarte a maximizar tu presencia en los medios. Desde la planificación estratégica hasta la ejecución de campañas, nos encargamos de cada detalle para garantizar que tu mensaje llegue a la audiencia adecuada en el momento oportuno.</p>
                            </div>
                            <div className="col-md-6">
                                <img alt="Servicios Digitales" src="/img/services/ServiciosDigitales/ServiciosDigitales_img2.webp"></img>
                            </div>
                        </div>
                        <div className="col-md-12 padding">
                            <hr className="hrGeneral"></hr>
                        </div>
                        <div className="col-md-12 padding paddingRightLeft0">
                            <div className="col-md-6 text-4">
                                <p>Una estrategia integral e integrada</p>
                            </div>
                            <div className="col-md-6 text-5">
                                <p>Nuestra estrategia está respaldada por datos del entorno, las audiencias, tu negocio y los medios propios, además de diversas fuentes de información. Más allá del alcance y la frecuencia, adoptamos un enfoque analítico, estratégico y creativo para transformar tu negocio.</p>
                            </div>
                        </div>
                        <div className="col-md-12 padding">
                            <hr className="hrGeneral"></hr>
                        </div>
                        <div className="col-md-12 padding paddingRightLeft0">
                            <div className="col-md-6 text-4">
                                <p>Potenciamos tu rendimiento<br></br>
                                    y reducimos los costes de medios<br></br>
                                    de comunicación con un modelo 4D</p>
                            </div>
                            <div className="col-md-6 text-5">
                                <div className="col-md-12 col-xs-12 text-left icono paddingRightLeft0 paddingTopBottom8">
                                    <div className="col-md-2 col-xs-2 paddingRightLeft0">
                                        <img alt="Exploracion" src="/img/services/ServiciosDigitales/Icono_Exploracion.webp"></img>
                                    </div>
                                    <div className="col-md-10 col-xs-10">
                                        <span><b>Exploración:</b> analizamos el mercado, la competencia y el público objetivo para obtener una visión clara del panorama actual y las oportunidades clave.</span>
                                    </div>
                                </div>
                                <div className="col-md-12 col-xs-12 text-left icono paddingRightLeft0 paddingTopBottom8">
                                    <div className="col-md-2 col-xs-2 paddingRightLeft0">
                                        <img alt="Estrategia" src="/img/services/ServiciosDigitales/Icono_Estrategia.webp"></img>
                                    </div>
                                    <div className="col-md-10  col-xs-10">
                                        <span><b>Estrategia:</b> combinamos diferentes elementos para crear un plan sólido y coherente.</span>
                                    </div>
                                </div>
                                <div className="col-md-12 col-xs-12 text-left icono paddingRightLeft0 paddingTopBottom8">
                                    <div className="col-md-2 col-xs-2 paddingRightLeft0">
                                        <img alt="Implementacion" src="/img/services/ServiciosDigitales/Icono_Implementacion.webp"></img>
                                    </div>
                                    <div className="col-md-10 col-xs-10">
                                        <span><b>Implementación:</b> ponemos en marcha el plan de acción de manera eficiente y precisa, maximizando la cobertura y el impacto de los medios de comunicación.</span>
                                    </div>
                                </div>
                                <div className="col-md-12 col-xs-12 text-left icono paddingRightLeft0 paddingTopBottom8">
                                    <div className="col-md-2 col-xs-2 paddingRightLeft0">
                                        <img alt="Smart Data" src="/img/services/ServiciosDigitales/Icono_SmartData.webp"></img>
                                    </div>
                                    <div className="col-md-10 col-xs-10">
                                        <span><b>Smart Data Driven:</b> Utilizamos datos avanzados y tecnología para extraer conocimientos valiosos de las métricas y el comportamiento del público objetivo, mejorando continuamente los resultados.</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-md-12 padding paddingRightLeft0">
                <div className="col-md-12 background paddingRightLeft0" style={{ background: "url('../img/services/CrecimientoExpo/CrecimientoExpo_img3.webp')", backgroundSize: 'cover' }}>
                        <div className="col-md-6 text-2 paddingRightLeft0">
                            <p>Desbloquea el éxito de tu proyecto de medios con un modelo innovador que fusiona estrategia, táctica y negocio. </p>
                        </div>
                    </div>
                </div>
                <div className="paddingTopBottom16">
                    &nbsp;
                </div>
                <div className="container-fluid padding-fluid ">
                    <div className="row">
                        <ServicesFooter data={props.data} id={1} />
                    </div>
                </div>
            </div>
        }

        
    </div>
  );
};
